export const FETCH_FULL_TRUCKLOADS = "FETCH_FULL_TRUCKLOADS"
export const DELETE_FULL_TRUCKLOAD = "DELETE_FULL_TRUCKLOAD"
export const REIMPORT_FTL_FINAL_DOC = "REIMPORT_FTL_FINAL_DOC"
export const STORE_FULL_TRUCKLOAD = "STORE_FULL_TRUCKLOAD"
export const SAVE_FULL_TRUCKLOAD = "SAVE_FULL_TRUCKLOAD"
export const REGENERATE_FTL_DOCUMENT = "REGENERATE_FTL_DOCUMENT"
export const STORE_PRODUCTS_SUPPLIERS = "STORE_PRODUCTS_SUPPLIERS"
export const FETCH_PRODUCT_SUPPLIERS = "FETCH_PRODUCT_SUPPLIERS"
export const UPDATE_FULL_TRUCKLOAD = "UPDATE_FULL_TRUCKLOAD"
export const UPLOAD_SIGNED_DOCUMENTS = "UPLOAD_SIGNED_DOCUMENTS"
export const SAVE_FULL_TRUCKLOAD_SETTINGS = "SAVE_FULL_TRUCKLOAD_SETTINGS"
export const SAVE_FULL_TRUCKLOAD_SIGNATURES = "SAVE_FULL_TRUCKLOAD_SIGNATURES"
export const LIST_FULL_TRUCKLOAD_NOA_PORTS = "LIST_FULL_TRUCKLOAD_NOA_PORTS"
export const SAVE_FULL_TRUCKLOAD_NOA_PORTS = "SAVE_FULL_TRUCKLOAD_NOA_PORTS"
export const CLEAR_RESPONSE_MESSAGE = "CLEAR_RESPONSE_MESSAGE"
export const STORE_SAVE_FTL_SETTING_RESPONSE = "STORE_SAVE_FTL_SETTING_RESPONSE"
export const CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE = "CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE"
export const LIST_FULL_TRUCKLOAD_SIGNATURES = "LIST_FULL_TRUCKLOAD_SIGNATURES"
export const STORE_FULL_TRUCKLOAD_SETTINGS = "STORE_FULL_TRUCKLOAD_SETTINGS"
export const STORE_SAVE_SIGNATURE_RESPONSE = "STORE_SAVE_SIGNATURE_RESPONSE"
export const STORE_SAVE_POE_RESPONSE = "STORE_SAVE_POE_RESPONSE"
export const STORE_FULL_TRUCKLOAD_SIGNATURES = "STORE_FULL_TRUCKLOAD_SIGNATURES"
export const STORE_FULL_TRUCKLOAD_PORTS = "STORE_FULL_TRUCKLOAD_PORTS"
export const FETCH_FULL_TRUCKLOAD_SETTINGS = "FETCH_FULL_TRUCKLOAD_SETTINGS"
export const PREVIEW_FULL_TRUCKLOAD_FILE = "PREVIEW_FULL_TRUCKLOAD_FILE"
export const STORE_FULL_TRUCKLOAD_FILE = "STORE_FULL_TRUCKLOAD_FILE"
export const STORE_FULL_TRUCKLOAD_SIGNATURE = "STORE_FULL_TRUCKLOAD_SIGNATURE"
export const PREVIEW_FULL_TRUCKLOAD_DOCUMENT = "PREVIEW_FULL_TRUCKLOAD_DOCUMENT"
export const STORE_FULL_TRUCKLOAD_DOCUMENT = "STORE_FULL_TRUCKLOAD_DOCUMENT"
export const LIST_FULL_TRUCKLOAD_CARRIERS = "LIST_FULL_TRUCKLOAD_CARRIERS"
export const STORE_FULL_TRUCKLOAD_CARRIERS = "STORE_FULL_TRUCKLOAD_CARRIERS"
export const LIST_FULL_TRUCKLOAD_BROKERS = "LIST_FULL_TRUCKLOAD_BROKERS"
export const STORE_FULL_TRUCKLOAD_BROKERS = "STORE_FULL_TRUCKLOAD_BROKERS"
export const STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE = "STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE"
export const STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS = "STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS"
export const UPDATE_FTL_DRAFT = "UPDATE_FTL_DRAFT"

